import './page/hueb-seo-conversion-create';
import './page/hueb-seo-conversion-detail';

import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

const {Module} = Shopware;

Module.register('hueb-seo-conversion', {
    type: 'plugin',
    name: 'hueb-seo-conversion',
    title: 'hueb-seo-conversion.conversion.header',
    description: 'sw-property.general.descriptionTextModule',
    color: '#ff3d58',
    icon: 'default-avatar-single',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },

    routes: {
        create: {
            component: 'hueb-seo-conversion-create',
            path: 'create',
        },
        detail: {
            component: 'hueb-seo-conversion-detail',
            path: 'detail',
        },
    },

    navigation: [{
        id: 'sw-hueb-seo-conversion',
        label: 'hueb-seo-conversion.conversion.header',
        path: 'hueb.seo.conversion.detail',
        parent: 'sw-marketing',
        position: 110,
        icon: 'default-avatar-single',
        color: '#ff3d58'
    },
    ]
});
